import { useState, useEffect, useRef } from "react";

import CancelIcon from "./img/cancel.webp";
import CheckIcon from "./img/check.webp";
import ConfirmButton from "./ConfirmButton";

function KachelAbschluss({ loading, kachelAbschliessen, kachelId, eskstatus }) {
   function handleKachelAbschluss() {
      kachelAbschliessen(eskstatus["kachel_status_" + kachelId] < 3, kachelId);
   }
   {
      /* <button
          title="Kachel komplett abschließen"
          className="share-button"
          onClick={handleShow}
        >
          <img src={CheckIcon} />
        </button> */
   }

   return (
      <>
         {eskstatus["kachel_status_" + kachelId] < 3 ? (
            <ConfirmButton
               myFunction={handleKachelAbschluss}
               myText={"Diese Kachel komplett abschliessen?"}
               myName={""}
               myIcon={CheckIcon}
               myStyle={{}}
               myClassName={"share-button"}
            />
         ) : (
            <ConfirmButton
               myFunction={handleKachelAbschluss}
               myText={"Abschluss dieser Kachel zurücksetzen?"}
               myName={""}
               myIcon={CancelIcon}
               myStyle={{}}
               myClassName={"share-button"}
            />
         )}
      </>
   );
}
export default KachelAbschluss;
